<template>
  <article class="layout-section">
    <div class="layout-section__hgroup">
      <h2 class="layout-section__title">Grid Panel</h2>
      <p>
        <span class="type-code">layout-grid.scss</span>
        &
        <span class="type-code">grid-panel.scss</span>
      </p>
    </div>

    <article class="layout-grid">
      <router-link to="/about" class="card grid-pannel__box" style="background-image: url('/images/bg-small-1.png')">
        <h3 class="grid-pannel__title">Panel 1</h3>
        <p>Voluptate sunt rem turpis blandit vestibulum quisque at officiis quisque</p>
      </router-link>

      <router-link to="/about" class="card grid-pannel__box" style="background-image: url('/images/bg-small-2.png')">
        <h3 class="grid-pannel__title">Panel 2</h3>
        <p>Voluptate sunt rem turpis blandit vestibulum quisque at officiis quisque</p>
      </router-link>

      <router-link to="/about" class="card grid-pannel__box" style="background-image: url('/images/bg-small-3.png')">
        <h3 class="grid-pannel__title">Panel 3</h3>
        <p>Voluptate sunt rem turpis blandit vestibulum quisque at officiis quisque</p>
      </router-link>

      <router-link to="/demo" class="card grid-pannel__box" style="background-image: url('/images/bg-small-2.png')">
        <h3 class="grid-pannel__title">Panel 4</h3>
        <p>Voluptate sunt rem turpis blandit vestibulum quisque at officiis quisque</p>
      </router-link>
    </article>
  </article>
</template>

<script>
export default {
  name: 'DemoGridPanel'
}
</script>
